import { Form } from 'antd';
import moment, { Moment } from 'moment';
import React, { FC, useMemo } from 'react';

import { TRANSLATION_CODES } from '../../constants';
import { applyTZToISODate, toISODateString } from '../../utils';
import { JRangePicker } from './../../../JForm/JRangePicker';
import { JDateRangeProps } from './../../models';
import { useCompositorContext } from './../CompositorProvider';
import { FormItem } from './../FormItem';


export const JDatesRange: FC<JDateRangeProps> = props => {
    const formInstance = Form.useFormInstance()
    const { formatDate, formatDateTime } = useCompositorContext()
    const { translate } = useCompositorContext();

    const format = props.showTime ? formatDateTime : formatDate


    const defaultValue = useMemo(() => {
        if (props.value?.length) {
            const range: Moment[] = []

            const from = props.value[0] && moment(applyTZToISODate(props.value[0]))
            if (from) range[0] = from

            const to = props.value[1] && moment(applyTZToISODate(props.value[1]))
            if (to) range[1] = to

            return range
        }
        return []
    }, [props.value])

    const placeholder: [string, string] = useMemo(() => {
        return [translate(TRANSLATION_CODES.START_DATE), translate(TRANSLATION_CODES.END_DATE)]
    }, [])

    const onChange = (values: [Moment, Moment]) => {
        if (values?.length) {
            const dates: string[] = []
            for (const value of values) {
                dates.push(toISODateString(value))
            }
            formInstance.setFieldValue(props.name, dates)
        } else {
            formInstance.setFieldValue(props.name, undefined)
        }
    }


    return (
        <FormItem fieldProps={props} initialValue={props.value}>
            <JRangePicker
                onChange={onChange}
                placeholder={placeholder}
                minDate={props.minDate}
                maxDate={props.maxDate}
                defaultValue={defaultValue}
                showTime={props.showTime}
                disabled={props.disabled}
                format={props.format ?? format}
            />
        </FormItem>
    )
}